import mapboxgl from "mapbox-gl";
// mapboxgl.workerClass = require("worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker").default;

class Map {
  constructor(mapElement, mapData) {
    this.mapElement = mapElement;
    this.center = [mapData.lng, mapData.lat];
    this.zoom = mapData.zoom;
    this.marker = {
      url: mapData.markerUrl,
      title: mapData.markerTitle,
      marker: mapData.marker,
    };
    this.api = mapData.api;

    this.lazyInit(this.mapElement, this.initMap);
  }

  openGoogleMaps = () => {
    window.open(this.marker.url, "_blank");
  };

  initMap = () => {
    mapboxgl.accessToken = this.api;

    const map = new mapboxgl.Map({
      container: this.mapElement, // container ID
      style: "mapbox://styles/mapbox/light-v10", // style URL
      center: this.center, // starting position [lng, lat]
      zoom: this.zoom, // starting zoom
    });

    // const marker = new mapboxgl.Marker().setLngLat(this.center).addTo(map);

    const pin = document.createElement("div");
    pin.className = "marker crsor-pointer";
    pin.style.backgroundImage = `url(${this.marker.marker})`;
    pin.style.width = `30px`;
    pin.style.cursor = "pointer";
    pin.style.height = `42px`;
    pin.style.backgroundSize = "100%";
    pin.title = this.marker.title;

    pin.addEventListener("click", this.openGoogleMaps);

    new mapboxgl.Marker(pin).setLngLat(this.center).addTo(map);
  };

  //Intersection observer for map lazy loding
  lazyInit = (element, mapInit) => {
    const observer = new IntersectionObserver((entries) => {
      if (entries.some(({ isIntersecting }) => isIntersecting)) {
        observer.disconnect();
        mapInit();
      }
    });
    observer.observe(element);
  };
}

document.addEventListener("DOMContentLoaded", () => {
  const mapElement = document.querySelector("#map");

  if (typeof mapElement != "undefined" && mapElement != null) {
    const map = new Map(mapElement, map_data);
  }
});

// import leaflet from "leaflet";
// import "leaflet/dist/leaflet.css";

// class Map {
//   constructor(mapElement, mapData) {
//     this.mapElement = mapElement;
//     this.lat = mapData.lat;
//     this.lng = mapData.lng;
//     this.zoom = mapData.zoom;
//     this.marker = {
//       url: mapData.markerUrl,
//       title: mapData.markerTitle,
//       marker: mapData.marker,
//     };

//     this.lazyInit(this.mapElement, this.initMap);
//   }

//   openGoogleMaps = () => {
//     window.open(this.marker.url, "_blank");
//   };

//   initMap = () => {
//     const map = L.map(this.mapElement).setView([this.lat, this.lng], this.zoom, { zoomControl: false });

//     L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
//       maxZoom: 19,
//       attribution: "© OpenStreetMap",
//     }).addTo(map);

//     //adding custom marker to map
//     const mapMarker = L.icon({
//       iconUrl: this.marker.marker,
//       iconSize: [54, 66],
//       iconAnchor: [17, 51],
//       clickable: true,
//     });

//     L.marker([this.lat, this.lng], { icon: mapMarker }).addTo(map).on("click", this.openGoogleMaps);
//   };

//   //Intersection observer for map lazy loding
//   lazyInit = (element, mapInit) => {
//     const observer = new IntersectionObserver((entries) => {
//       if (entries.some(({ isIntersecting }) => isIntersecting)) {
//         observer.disconnect();
//         mapInit();
//       }
//     });
//     observer.observe(element);
//   };
// }

// document.addEventListener("DOMContentLoaded", () => {
//   const mapElement = document.querySelector("#map");

//   if (typeof mapElement != "undefined" && mapElement != null) {
//     const map = new Map(mapElement, map_data);
//   }
// });
